"use strict";

var _regeneratorRuntime = require("/vercel/path0/node_modules/@babel/runtime/regenerator");

require("regenerator-runtime/runtime");

var _classCallCheck = require("/vercel/path0/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/vercel/path0/node_modules/@babel/runtime/helpers/createClass");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MainSlim = void 0;

var tslib_1 = require("tslib");

var SquareDrawer_1 = require("./ShapeDrawers/SquareDrawer");

var TextDrawer_1 = require("./ShapeDrawers/TextDrawer");

var ImageDrawer_1 = require("./ShapeDrawers/ImageDrawer");

var Utils_1 = require("./Utils");

var Types_1 = require("./Enums/Types");

var LineDrawer_1 = require("./ShapeDrawers/LineDrawer");

var CircleDrawer_1 = require("./ShapeDrawers/CircleDrawer");

var TriangleDrawer_1 = require("./ShapeDrawers/TriangleDrawer");

var StarDrawer_1 = require("./ShapeDrawers/StarDrawer");

var PolygonDrawer_1 = require("./ShapeDrawers/PolygonDrawer");

var Loader_1 = require("./Core/Loader");

var MainSlim = /*#__PURE__*/function () {
  function MainSlim() {
    _classCallCheck(this, MainSlim);

    this.initialized = false;
    var squareDrawer = new SquareDrawer_1.SquareDrawer();
    var textDrawer = new TextDrawer_1.TextDrawer();
    var imageDrawer = new ImageDrawer_1.ImageDrawer();
    Utils_1.Plugins.addShapeDrawer(Types_1.ShapeType.line, new LineDrawer_1.LineDrawer());
    Utils_1.Plugins.addShapeDrawer(Types_1.ShapeType.circle, new CircleDrawer_1.CircleDrawer());
    Utils_1.Plugins.addShapeDrawer(Types_1.ShapeType.edge, squareDrawer);
    Utils_1.Plugins.addShapeDrawer(Types_1.ShapeType.square, squareDrawer);
    Utils_1.Plugins.addShapeDrawer(Types_1.ShapeType.triangle, new TriangleDrawer_1.TriangleDrawer());
    Utils_1.Plugins.addShapeDrawer(Types_1.ShapeType.star, new StarDrawer_1.StarDrawer());
    Utils_1.Plugins.addShapeDrawer(Types_1.ShapeType.polygon, new PolygonDrawer_1.PolygonDrawer());
    Utils_1.Plugins.addShapeDrawer(Types_1.ShapeType["char"], textDrawer);
    Utils_1.Plugins.addShapeDrawer(Types_1.ShapeType.character, textDrawer);
    Utils_1.Plugins.addShapeDrawer(Types_1.ShapeType.image, imageDrawer);
    Utils_1.Plugins.addShapeDrawer(Types_1.ShapeType.images, imageDrawer);
  }

  _createClass(MainSlim, [{
    key: "init",
    value: function init() {
      if (!this.initialized) {
        this.initialized = true;
      }
    }
  }, {
    key: "loadFromArray",
    value: function loadFromArray(tagId, options, index) {
      return tslib_1.__awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt("return", Loader_1.Loader.loadFromArray(tagId, options, index));

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
    }
  }, {
    key: "load",
    value: function load(tagId, options) {
      return tslib_1.__awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                return _context2.abrupt("return", Loader_1.Loader.load(tagId, options));

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));
    }
  }, {
    key: "set",
    value: function set(id, element, options) {
      return tslib_1.__awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                return _context3.abrupt("return", Loader_1.Loader.set(id, element, options));

              case 1:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));
    }
  }, {
    key: "loadJSON",
    value: function loadJSON(tagId, pathConfigJson) {
      return Loader_1.Loader.loadJSON(tagId, pathConfigJson);
    }
  }, {
    key: "setOnClickHandler",
    value: function setOnClickHandler(callback) {
      Loader_1.Loader.setOnClickHandler(callback);
    }
  }, {
    key: "dom",
    value: function dom() {
      return Loader_1.Loader.dom();
    }
  }, {
    key: "domItem",
    value: function domItem(index) {
      return Loader_1.Loader.domItem(index);
    }
  }, {
    key: "addShape",
    value: function addShape(shape, drawer, init, afterEffect, destroy) {
      var customDrawer;

      if (typeof drawer === "function") {
        customDrawer = {
          afterEffect: afterEffect,
          destroy: destroy,
          draw: drawer,
          init: init
        };
      } else {
        customDrawer = drawer;
      }

      Utils_1.Plugins.addShapeDrawer(shape, customDrawer);
    }
  }, {
    key: "addPreset",
    value: function addPreset(preset, options) {
      Utils_1.Plugins.addPreset(preset, options);
    }
  }, {
    key: "addPlugin",
    value: function addPlugin(plugin) {
      Utils_1.Plugins.addPlugin(plugin);
    }
  }]);

  return MainSlim;
}();

exports.MainSlim = MainSlim;